import { createFileRoute } from "@tanstack/react-router";
import Financing from "@/pages/Financing";

export const Route = createFileRoute("/rv-financing")({
  // ?UnitId=… / ?s=… variants collapse onto the clean financing URL.
  head: () => ({
    meta: [
      { title: "RV Financing | Rex & Sons RVs" },
      { name: "description", content: "Apply for RV financing with Rex & Sons RVs in Castle Hayne, NC. Competitive rates for new and used RVs." },
      { property: "og:title", content: "RV Financing | Rex & Sons RVs" },
      { property: "og:description", content: "Apply for RV financing with Rex & Sons RVs in Castle Hayne, NC." },
      { property: "og:url", content: "https://www.rexandsonsrvs.com/rv-financing" },
    ],
    links: [{ rel: "canonical", href: "https://www.rexandsonsrvs.com/rv-financing" }],
  }),
  component: Financing,
});
